/* tslint:disable */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/do';
import { AppMessageService } from '../../shared/index';

@Injectable()
export class MessengerInterceptor implements HttpInterceptor {

	constructor(private messageService: AppMessageService) { }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do(event => {}, err => {
        if (err instanceof HttpErrorResponse) {
          this.messageService.httpStatusCode(err.status);
        }
    });
}
}



// WEBPACK FOOTER //
// ./src/core/interceptors/messenger.interceptor.ts